import axios from 'axios'
// import MD5 from 'md5.js'
// resizeParams
import {url} from './config'

axios.defaults.withCredentials = true;
axios.defaults.headers['Content-Type'] = 'application/x-www-form-urlencoded'

function createSearchParams(json) {
    let param = new URLSearchParams();
    for (var key in json) {
        param.append(key, json[key]);
    }
    return param;
}

// 检查token是否过期
function checkToken(token, deptId) {
    return new Promise(resolve => {
        axios.get(url + '/spm/vrifyToken', {
            params: {
                token,
                deptId
            }
        }).then(res => {
            resolve(res.data)
        })
    })
}

//获取组织机构
function getDept(deptId){
    return new Promise(resolve => {
        axios({
            method: 'get',
            url: url + '/spm/getDept',
            params:{
                deptId
            }
        }).then((res)=>{
            resolve(res.data)
        })
    })
}

function toFormData(json) {
    let formData = new FormData()
    for (let key in json) {
        if (json[key]) {
            formData.append(key, json[key])
        }
    }
    return formData

}

export {
    createSearchParams,
    getDept,
    checkToken,
}